import { ApolloThunkMutation } from "../../../../apolloClient/types"
import { apolloMutation } from "../../../../apolloClient/utils"

import { MUTATION } from "./mutation"

type Data = {
  updateOfferPurchase: boolean
}

export type UpdateOfferPurchaseInput = {
  id: string
  duration: number
  pricePerHour: number
}

type Variables = {
  input: UpdateOfferPurchaseInput
}

export const updateOfferPurchaseThunk: ApolloThunkMutation<
  Data,
  [Variables["input"]]
> = async (state, input) => {
  const { data, errors } = await apolloMutation<Data, Variables>({
    state,
    mutation: MUTATION,
    variables: {
      input,
    },
  })

  return {
    updateOfferPurchaseData: data?.updateOfferPurchase,
    updateOfferPurchaseErrors: errors,
  }
}
